import { DefaultsApi, useAPIQuery } from "melco-shared-logic";

export const useGetAllCultures = () => {
  const query = useAPIQuery(DefaultsApi, ["getAllCutures"], async (api) => {
    let response;
    response = await api.defaultsSearchCultures({});

    const cultures = (response.list ?? []).map(
      ({ code, id, name, short_code }) => {
        return {
          name: name ?? "",
          code: code ?? "",
          id: id ?? "",
          short_code: short_code ?? "",
        };
      }
    );

    return cultures;
  });

  return query;
};
